import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import {
  knmSetErknmKnoOrganizationFormValue,
  knmSetErknmSupervisionTypeFormValue,
  knmSetErknmKnmKindVersionIdFormValue,
  knmSetErknmReasonFormValue,
} from 'KnmPackage/MainModule/actions/knmActions';

import { IKnmPmForm } from '../interfaces/IKnmPmForm';

export function useKnmPm(values: IKnmPmForm) {
  const dispatch = useDispatch();
  const formKnoOrganization = values.knoOrganizationPm;
  const formSupervisionType = values.supervisionTypePm;
  const formKnmKindDictVersionId = values.pmType?.value.dictVersionId;
  const formReasons = values.reasonsPm;

  const setKnoOrganizationFormValue = useCallback(
    () => dispatch(knmSetErknmKnoOrganizationFormValue(formKnoOrganization)),
    [dispatch, formKnoOrganization],
  );

  useEffect(() => {
    setKnoOrganizationFormValue();
  }, [setKnoOrganizationFormValue]);

  const setSupervisionTypeFormValue = useCallback(
    () => dispatch(knmSetErknmSupervisionTypeFormValue(formSupervisionType)),
    [dispatch, formSupervisionType],
  );

  useEffect(() => {
    setSupervisionTypeFormValue();
  }, [setSupervisionTypeFormValue]);

  const setKnmKindFormValue = useCallback(
    () => dispatch(knmSetErknmKnmKindVersionIdFormValue(formKnmKindDictVersionId)),
    [dispatch, formKnmKindDictVersionId],
  );

  useEffect(() => {
    setKnmKindFormValue();
  }, [setKnmKindFormValue]);

  const setReasonsFormValue = useCallback(() => {
    dispatch(knmSetErknmReasonFormValue(formReasons));
  }, [dispatch, formReasons]);

  useEffect(() => {
    setReasonsFormValue();
  }, [setReasonsFormValue]);
}
